export default {
  navigationBarTitleText: intl.get('home.profile')
};
